import { render, staticRenderFns } from "./EditWord.vue?vue&type=template&id=5b82459c&"
import script from "./EditWord.vue?vue&type=script&lang=ts&"
export * from "./EditWord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports